module.exports = __webpack_public_path__ + "static/media/visualmanagement.410bdbfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/visualmanagement.png
// module id = 583
// module chunks = 1